module.exports = __webpack_public_path__ + "img/tab-baseinfo-active.865a6cb9.png";